/**
 * 页面加载组件 - 全屏加载指示器
 * 
 * 功能特性：
 * - 全屏居中显示
 * - 品牌色加载动画
 * - 可选加载文本
 */

import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import styles from './PageLoading.module.scss';

interface PageLoadingProps {
  tip?: string;
  size?: 'small' | 'default' | 'large';
}

/**
 * 页面加载组件
 */
export const PageLoading: React.FC<PageLoadingProps> = ({ 
  tip = '加载中...', 
  size = 'large' 
}) => {
  const antIcon = <LoadingOutlined style={{ fontSize: 48 }} spin />;

  return (
    <div className={styles.pageLoading}>
      <Spin 
        indicator={antIcon} 
        tip={tip} 
        size={size}
        fullscreen
        className={styles.spinner}
      />
    </div>
  );
};

export default PageLoading;
